<template>
  <div class="price-breakdown">
    <div class="price-breakdown__row">
      <span>Сумма без НДС:</span>
      <span>{{ formatPrice(baseAmount) }}</span>
    </div>
    <div class="price-breakdown__row">
      <span>НДС:</span>
      <span>{{ formatPrice(safeTaxAmount) }}</span>
    </div>
    <div v-if="showDelivery" class="price-breakdown__row">
      <span>Доставка:</span>
      <span>{{ deliveryLabel }}</span>
    </div>
    <hr class="price-breakdown__divider" />
    <div class="price-breakdown__row price-breakdown__row--total">
      <span>Итого:</span>
      <span>{{ formatPrice(finalTotal) }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  totalAmount: number
  taxAmount?: number
  deliveryAmount?: number
  deliveryLabel?: string
  showDelivery?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  taxAmount: 0,
  deliveryAmount: 0,
  deliveryLabel: 'Бесплатно',
  showDelivery: true,
})

// Безопасное преобразование пропсов в числа
const safeTotalAmount = computed(() => {
  const value = props.totalAmount
  if (typeof value === 'number' && !isNaN(value)) {
    return value
  }
  if (typeof value === 'string') {
    const parsed = parseFloat(value)
    return isNaN(parsed) ? 0 : parsed
  }
  return 0
})

const safeTaxAmount = computed(() => {
  const value = props.taxAmount ?? 0
  if (typeof value === 'number' && !isNaN(value)) {
    return value
  }
  if (typeof value === 'string') {
    const parsed = parseFloat(value)
    return isNaN(parsed) ? 0 : parsed
  }
  return 0
})

const safeDeliveryAmount = computed(() => {
  const value = props.deliveryAmount ?? 0
  if (typeof value === 'number' && !isNaN(value)) {
    return value
  }
  if (typeof value === 'string') {
    const parsed = parseFloat(value)
    return isNaN(parsed) ? 0 : parsed
  }
  return 0
})

const baseAmount = computed(() => Math.max(0, safeTotalAmount.value - safeTaxAmount.value))
const finalTotal = computed(() => safeTotalAmount.value + safeDeliveryAmount.value)

const formatPrice = (priceRubles: number): string => {
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    maximumFractionDigits: 2,
  }).format(priceRubles)
}
</script>

<style scoped>
.price-breakdown__row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.price-breakdown__row--total {
  margin-top: 12px;
  margin-bottom: 0;
  font-weight: 600;
  font-size: 1.05em;
}

.price-breakdown__divider {
  border: none;
  border-top: 1px solid #e2e8f0;
  margin: 12px 0 0;
}
</style>
